/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */
import {
  ProFormUploadButton,
  type ProFormUploadButtonProps,
} from '@ant-design/pro-components';
import type { FunctionComponent } from 'react';
import Footer from './Footer';
import HeaderNoticeEntry from './HeaderNoticeEntry';
import ImageCropModal from './ImageCropModal';
import ImageUploadPreview from './ImageUploadPreview';
import { Question, SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';
import PoolSwitcher from './PoolSwitcher';
import SubSystemEntry from './SubSystemEntry';

export const UploadButton =
  ProFormUploadButton as FunctionComponent<ProFormUploadButtonProps>;

export { default as PermissionWrapper } from './PermissionWrapper';
export {
  AvatarDropdown,
  AvatarName,
  Footer,
  HeaderNoticeEntry,
  ImageCropModal,
  ImageUploadPreview,
  PoolSwitcher,
  Question,
  SelectLang,
  SubSystemEntry,
};
